import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { IAccount } from '@/models';

const useShowCareLink = (account: IAccount | null) => {
  const { pathname } = useLocation();

  const includedPaths = ['/cfs', '/cfs-active'];
  const includedPathsPattern = new RegExp(
    `^(${includedPaths
      .map((path) => path.replace(/\//g, '\\/'))
      .join('|')})(/[^/]+)*$`,
  );

  const [showCareLink, setShowCareLink] = useState(false);

  useEffect(() => {
    if (!account) return;

    const isEnabledNursingHome =
      account?.settings?.features?.isEnabledNursingHome;

    const isIncludedPage = includedPathsPattern.test(pathname);
    const shouldShow = isIncludedPage && !!isEnabledNursingHome;

    setShowCareLink(shouldShow);
  }, [pathname, account]);

  return showCareLink;
};

export default useShowCareLink;
